import { connect } from 'react-redux';
import { getIsCurrentUserAuthorOf } from '../../redux/deviations/selectors';
import { actions as modalActions } from '../../Modals';
const mapStateToProps = (state, ownProps)=>({
        isCreator: getIsCurrentUserAuthorOf(state, ownProps.deviation)
    });
const mapDispatchToProps = (dispatch, ownProps)=>({
        openListingModal: (deviation)=>{
            dispatch(modalActions.pushDasModal('listing', deviation));
        },
        openBidModal: (deviation)=>{
            dispatch(modalActions.pushDasModal('bid', deviation));
        },
        openManageModal: (deviation)=>{
            dispatch(modalActions.pushDasModal('manage', deviation));
        }
    });
export default connect(mapStateToProps, mapDispatchToProps);
